import { createAsyncThunk } from '@reduxjs/toolkit';

import { sendSentryClientErrorOnce } from 'shared/lib/sendSentryClientError';

import { getStAffAndOfferFromUrl, getStAttributionParamsFromUrl, getStParentId, setStParentIdOnce } from '../../lib';
import { stTrackingApi } from '../stTracking.query';

type TResolveStParentIdThunkPayload = {
  sourceUrl?: string;
  affId?: string;
  offerId?: string;
};

export const resolveStParentIdThunk = createAsyncThunk<string | null, TResolveStParentIdThunkPayload>(
  'stTracking/resolveStParentIdThunk',
  async ({ sourceUrl, affId, offerId }, { dispatch }) => {
    try {
      const existingStParentId = getStParentId();

      if (existingStParentId) {
        return existingStParentId;
      }

      const stAffAndOffer =
        affId && offerId
          ? {
              affId,
              offerId,
            }
          : getStAffAndOfferFromUrl(sourceUrl);

      if (!stAffAndOffer) {
        return null;
      }

      const attribution = getStAttributionParamsFromUrl(sourceUrl);

      const response = await dispatch(
        stTrackingApi.endpoints.stTrackingClick.initiate({
          affId: stAffAndOffer.affId,
          offerId: stAffAndOffer.offerId,
          isFirstTouch: true,
          ...attribution,
        }),
      ).unwrap();

      return response?.transaction_id ? setStParentIdOnce(response.transaction_id) : null;
    } catch (error) {
      sendSentryClientErrorOnce('resolveStParentIdThunk', error);
      return null;
    }
  },
);
